export enum ProductionTypeEnum { 
    GRN ='GRN',
    RE_PACKING ='RE PACKING',
    RE_PROCESSING ='RE PROCESSING',
 }